import { Permissions } from '../../models/enums/permissions';
import * as React from 'react';
import { HasPermission } from '../../containers/authorization-helpers/HasPermission';

interface IProps {
    completeSelections: any;
    printJobs: any;
    downloadSelections: any;
    clearSelections: any;
    heightOffset: number;
}

export const JobRightClickMenu = (props : IProps) => {
    return (
        <div>
            <p>Job Actions</p>
            
            <HasPermission requiredPermissions={[
                Permissions.ProductionScheduleView
            ]}>
                <button onClick={ props.downloadSelections }>
                    <i className="la la-download"/>
                    Download Paperwork
                </button>
            </HasPermission>

            <HasPermission requiredPermissions={[
                Permissions.ProductionScheduleJobs
            ]}>
                <button onClick={ props.printJobs }>
                    <i className="la la-print"/>
                    Print Job(s)
                </button>
            </HasPermission>
            
            <HasPermission requiredPermissions={[
                Permissions.ProductionScheduleJobs
            ]}>
                <button onClick={ props.completeSelections }>
                    <i className="la la-check-circle"/>
                    Complete Job(s)
                </button>
            </HasPermission>

            <div className="right-click-divide" />
            <button onClick={ props.clearSelections }>
                <i className="la la-eraser"/>
                Clear Selection(s)
            </button>

        </div>        
    );

};
